
import { makeStyles } from '@material-ui/core/styles';
import { Box, Container, Typography } from "@mui/material";
import CardServices from "../../../utils/cardServices";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        alignItems: "center",
        alignContent: "center",
        minHeight: '50vh',
        backgroundImage: 'url(/img/backGrounds/BgComprimido.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        marginTop: -5,
        boxShadow: '1rem 1rem 1rem #e7f0ed',

        // [theme.breakpoints.down('xs')]: {
        //     backgroundPosition: 'left',
        //     alignItems: "left",
        // },
    },

    containerCardesService: {
        // padding: '2rem',
        // maxWidth:680,
        display: 'flex',
        flexWrap: 'wrap',
        placeItems: "center",
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: "center",
        /* AFASTAR UM ITEM DO OUTRO */
        gap: '2rem',
    }
}))

export default function Servicos({definicoesSistema}) {
    const classes = useStyles();
    // console.log(definicoesSistema)

    const serviceStatus = (servico)=>{
        if (definicoesSistema?.servicos.includes(servico)) return true;
    }

    return (
        <div className={classes.root} >
            <Container >
                <Typography align="center" variant="h1" style={{ margin: 30, fontSize: 25, fontWeight: 'bold' }}>
                    SERVIÇOS
                </Typography>

                <Box className={classes.containerCardesService}>
                    <CardServices status={serviceStatus('informacoes')} icone={'/icones/Informacoes.svg'} nomeService={'Informações'} link={'/informacoes'} />
                    <CardServices status={serviceStatus('agenda')} icone={'/icones/Agenda2.svg'} nomeService={'Marcação de agenda'} link={'/agenda-disponivel'} />
                    <CardServices status={serviceStatus('renovacaoAutorizacao')} icone={'/icones/renovacaoLicenciamento.svg'} nomeService={'Renovação da Autorização de exercico farmacêutico'} link={'/solicitacao-de-renovacao-de-estabelecimento'} />
                    <CardServices status={serviceStatus('autorizados')} icone={'/icones/Medicamentos_autorizados.svg'} nomeService={'Medicamentos Aprovados'} link={'/medicamentos/aprovado?page=1'} />
                    <CardServices status={serviceStatus('reclamacao')} icone={'/icones/Reclamacoes.svg'} nomeService={'Reclamação'} link={'/utente/reclamacao/fazer-reclamacao'} />
                    <CardServices status={serviceStatus('estabelecimentosLicenciados')} icone={'/icones/Licenciamento.svg'} nomeService={'Estabelecimentos Licenciados'} link={'/estabelecimentos-categorias-armed'} />
                    {/* <CardServices status={true} icone={'/icones/iconExpediente-03.svg'} nomeService={'Expediente'} link={'/utente/form/expediente'} /> */}
                    <CardServices status={serviceStatus('importacaoExportacao')} icone={'/icones/Import_export.svg'} nomeService={'Importação & Exportação'} link={'/importacao-e-exportacao'} />
                    <CardServices status={serviceStatus('certificadoProdutosControlados')} icone={'/icones/Import_export.svg'} nomeService={'Solicitação de Certificado de Produtos Contralados'} link={'inspeccao-regulatoria/solicitacao/certificado-produto-controlado/PRODUTOS CONTROLADOS'} /> {/* /solicitacao/certificado/productos-controlados*/}
                    {/* <CardServices status={true} icone={'/icones/Desalfandegar.svg'} nomeService={'Inspecção Regulatória'} link={'/inspeccao-regulatoria'} /> */}
                    <CardServices status={serviceStatus('desalfandegamento')} icone={'/icones/Desalfandegar.svg'} nomeService={'Solicitação de Desalfandegamento'} link={'/solicitacao-de-desalfandegamento'} />
                    <CardServices status={serviceStatus('analiseLaboratorial')} icone={'/icones/controleQualidade/solicitacoesAnalise.svg'} nomeService={'Laboratório de Controle de Qualidade'} link={'/opcoes/controle-de-qualidade'} /> 
                    <CardServices status={serviceStatus('farmacovigilancia')} icone={'/icones/controleQualidade/solicitacoesAnalise.svg'} nomeService={'Farmacovigilância'} link={'/farmacovigilancia-forlumarios'} />
                    <CardServices status={serviceStatus('registosMedicamentos')} icone={''} nomeService={'Registo de Medicamentos'} link={'/informacoes-sobre-pedido-de-aim'} />
                    {/* <CardServices status={serviceStatus('financas')} icone={''} nomeService={'Finanças'} link={'/financas'} />   //formulario-de-solicitacao-de-analise-laboratorial */}
                    <div style={{ width: '19%', minWidth: 200 }} />
                </Box>
            </Container>
        </div>
    )
}


